<script>
import Layout from '@layout/main'
import { authComputed } from '@store/helpers'
import Box from '@components/List/Box'

export default {
  page() {
    return {
      title: `會員中心`,
    }
  },
  components: {
    Layout,
    Box,
  },
  data() {
    return {
      loadingLogout: false,
      menuList: [
        {
          name: '會員設定',
          alias: 'member-setting',
          icon: '<i class="icomoon icon-member font-thin"></i>',
        },
        {
          name: '報名清單',
          alias: 'member-event-list',
          icon: '<i class="icomoon icon-member-list font-thin"></i>',
        },
        {
          name: '上課卷',
          alias: 'member-coupon-list',
          icon: '<i class="fal fa-ticket-alt font-thin"></i>',
          isCircle: true,
        },
      ],
      mobileMenuList: [
        {
          name: '會員設定',
          to: {
            name: 'member-info',
          },
          icon: '<i class="icomoon icon-primary-user"></i>',
        },
        {
          name: '報名清單',
          to: {
            name: 'member-event-list',
          },
          icon: '<i class="icomoon icon-primary-file"></i>',
        },
        {
          name: '上課卷',
          to: {
            name: 'member-coupon-list',
          },
          icon: '<i class="fal fa-ticket-alt color-primary"></i>',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
  created() {
    this.$store.dispatch('auth/fetchUser')
  },
  methods: {
    goToView(name) {
      this.$router.push({ name })
    },
    async tryToLogout() {
      this.loadingLogout = true
      await this.$store
        .dispatch('auth/logOut')
        .then(() => {
          this.$router.push({ name: 'home' })
          // if(this.$route.query?.redirectFrom && this.$route.query?.redirectFrom.indexOf(this.$globalSubSiteUrl)) {
          //   console.log(this.$router.history.current.query.redirectFrom)
          //   window.location = this.$route.query?.redirectFrom
          // } else {
          //   this.$router.push({ name: 'home' });
          // }
        })
        .finally(() => {
          this.loadingLogout = false
        })
    },
  },
}
</script>
<template>
  <Layout>
    <BaseBanner title="會員中心" :image="require('@assets/images/member/banner.png')" custom-class="isStyleWhite" type="isMobileHasBg" />
    <section class="section" :class="$style.sectionMember">
      <div class="container">
        <div class="text-center mb-3">
          <span class="lg:text-xl text-sm">Hello,</span>
          <span class="text-base lg:text-3xl color-primary ml-2">
            <template v-if="currentMember && currentMember.name">{{ currentMember.name }}</template>
            <template v-else>零壹會員</template>
          </span>
          <template v-if="currentMember.group === '經銷會員' && currentMember.dealerValidate === false">
            <span class="text-center memberBack warningLevel"> 經銷會員未驗證 </span>
          </template>
          <template v-else-if="currentMember.group === '經銷會員' && currentMember.dealerValidate && currentMember.dealerExpired">
            <span class="text-center memberBack warningLevel"> 經銷會員(已過期)</span>
          </template>
          <template v-else>
            <span :class="currentMember.group === '經銷會員' ? 'dealerLevel' : 'normalLevel'" class="text-center memberBack"> {{ currentMember.group }} </span>
          </template>
        </div>
        <div class="text-base md:text-lg text-center mb-5"> 歡迎來到零壹科技會員中心，祝你有個美好的一天！ </div>
        <div class="sectionMember__menuList row mobileGutter">
          <div v-for="(menu, index) in menuList" :key="`menu-${index}`" class="sectionMember__menuList__item col-md-3 col-6 mb-md-0 mb-4 d-md-block d-none">
            <div class="sectionMember__block" @click="goToView(menu.alias)">
              <div class="sectionMember__blockInner">
                <div class="sectionMember__icon" :class="{ isCircle: menu.isCircle }" v-html="menu.icon"></div>
                <div class="sectionMember__title">{{ menu.name }}</div>
              </div>
            </div>
          </div>
          <div class="sectionMember__menuList__item col-md-3 col-6 mb-md-0 mb-4 d-md-block d-none">
            <div class="sectionMember__block" @click="tryToLogout">
              <div class="sectionMember__blockInner">
                <div class="sectionMember__icon">
                  <i class="icomoon icon-member-log-out font-thin"></i>
                </div>
                <div class="sectionMember__title">登出帳號</div>
              </div>
            </div>
          </div>
          <template v-for="(menu, index2) in mobileMenuList">
            <Box :key="`mobilemenu-${index2}`" class="col-6 mb-3 d-md-none" :item="menu" />
          </template>
          <div :class="$style.Box" class="col-6 mb-3 d-md-none">
            <div class="Box__block" @click="tryToLogout">
              <div class="Box__blockInner">
                <div class="Box__icon">
                  <i class="icomoon icon-primary-logout"></i>
                </div>
                <div class="Box__title">登出帳號</div>
              </div>
            </div>
          </div>
        </div>
        <div class="sectionMember__menuList"> </div>
      </div>
    </section>
  </Layout>
</template>
<style lang="scss" module>
.sectionMember {
  :global {
    .sectionMember {
      &__menuList {
        &__item {
        }
      }

      &__block {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding-top: 100%;
        cursor: pointer;
        cursor: pointer;
        border: 1px solid #c6c6ba;
        transition: 0.3s;

        &:hover {
          border-color: $color-primary;

          .sectionMember {
            &__title {
              color: $color-primary;
            }

            &__icon {
              color: $color-primary;

              &.isCircle {
                border-color: $color-primary;
              }
            }
          }
        }
      }

      &__blockInner {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        text-align: center;
        text-indent: 0.25em;
        transform: translate(-50%, -50%);
      }

      &__icon {
        width: 60px;
        height: 60px;
        margin: 0 auto 2rem;
        font-size: 60px;
        color: #4d5561;
        background-position: center;
        background-size: cover;
        transition: 0.3s;

        @include max-md {
          width: 40px;
          height: 40px;
          font-size: 40px;
        }

        &.isCircle {
          width: 64px;
          height: 64px;
          margin-bottom: 1rem;
          font-size: 35px;
          line-height: 64px;
          background-repeat: no-repeat;
          background-position: center;
          background-size: 50%;
          border: 2px solid #4d5561;
          border-radius: 100%;
          // color:#4D5561;
          i {
            margin-left: -0.2em;
          }

          @include max-md {
            width: 44px;
            height: 44px;
            font-size: 15px;
            line-height: 44px;
          }
        }
      }

      &__title {
        font-size: 1.25rem;
        transition: 0.3s;

        @include max-md {
          font-size: 1rem;
        }
      }
    }
    .memberBack {
      color: $color-gray-4;
      font-size: 16px;
      border-radius: 5px;
      padding: 5px;
      width: 220px;
      margin-left: 10px;
    }
    .normalLevel {
      border: 1px solid $color-gray-3;
    }
    .dealerLevel {
      border: 1px solid $color-primary;
      color: $color-primary;
    }
    .warningLevel {
      border: 1px solid $color-warning;
      color: $color-warning;
    }
  }
  .Box {
    :global {
      .Box {
        &__block {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding-top: 100%;
          cursor: pointer;
          cursor: pointer;
          // border: 1px solid #C6C6BA;
          box-shadow: 0px 2px 6px rgba(33, 69, 88, 0.09);
          border-radius: 5px;
          transition: 0.3s;
          background: #fff;
        }

        &__blockInner {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          text-align: center;
          // text-indent: 0.25em;
          transform: translate(-50%, -50%);
        }

        &__icon {
          width: 60px;
          height: 60px;
          margin: 0 auto;
          font-size: 60px;
          color: #4d5561;
          background-position: center;
          background-size: cover;
          transition: 0.3s;

          @include max-md {
            width: 50px;
            height: 50px;
            font-size: 36px;
          }
        }

        &__title {
          font-size: 1.25rem;
          transition: 0.3s;
          margin-top: 0.875rem;
          @include max-md {
            font-size: 0.87125rem;
          }
        }
      }
    }
  }
}
</style>
